import moment from 'moment-timezone';

import { ISchedule } from '../schedule';
import { ISession, SingleCommunication } from '../session';

export interface IEpxAsthmaSchedule extends ISchedule {
  age?: number;
  height?: number;
  gender?: 'male' | 'female';
  normalPeakFlow?: number;
  hasPeakFlowMeter: boolean;
  shouldAskFever?: boolean;
}

export interface IEpxAsthma
  extends ISession<IEpxAsthmaSchedule>, SingleCommunication {
  breathing?: 0 | 1 | 2;
  peakFlow?: number;
  isPeakFlowConfirmed?: boolean;
  symptomsImproved?: boolean;
  rescueInhalerUses?: number;
  isInhalerConfirmed?: boolean;
  isScreening?: boolean;
  weeklyRescueUses?: number;
  rescueUsesInDay?: number;
  timesAwakened?: number;
  hasFever?: boolean;
}

export function ProcessSchedule<
  T extends {
    times: string[];
  }
>(data: T, schedule: IEpxAsthmaSchedule): T {
  const start = moment.tz(schedule.start, schedule.tz);
  const times = [start.format('HH:mm')];
  data.times = times;
  return data;
}
